import { render, staticRenderFns } from "./footPage.vue?vue&type=template&id=9b219480&scoped=true&"
import script from "./footPage.vue?vue&type=script&lang=js&"
export * from "./footPage.vue?vue&type=script&lang=js&"
import style0 from "./footPage.vue?vue&type=style&index=0&id=9b219480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b219480",
  null
  
)

export default component.exports